import React, { useEffect, useState } from "react";
import CheckList from "../component/CheckList";
import {
  deleteCheckListService,
  getCheckListQuestionsService,
  getCheckListResponseService,
  getCheckListService,
} from "../services/CheckListService";
import { Apinames } from "../utils/Apiname";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../utils/Common";

type Props = { isTemplate: boolean };

const CheckListScreen = (props: Props) => {
  const navigate = useNavigate();
   const { state } = useLocation();
  const [allList, setAllList] = useState<any[]>([]);
  const [dropDownList, setDropDownList] = useState<any[]>([]);

  const [questionList, setQuestionList] = useState<any[]>([]);
  const [responsesList, setResponsesList] = useState<any[]>([]);
  const [selectedChecklistId, setSelectedChecklistId] = useState<number | null>(
    null
  );
  const [role, setRole] = useState<string | null>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [dropdownLoading, setDropdownLoading] = useState<boolean>(false);


  const [error, setError] = useState<string | null>(null);

  const [show, setShow] = useState(false);
  const [usershow, setUserShow] = useState(false);

  useEffect(() => {
    const cookie: any = getCookie("data");
    setRole(cookie.role || null);
  }, []);

  useEffect(() => {
    getCheckList();
  }, [props.isTemplate]);

  const getCheckList = async () => {
    try {
      setError(null);
      let endpoint = `${Apinames.checklistAll}?isTemplate=${props.isTemplate}`;
      const response = await getCheckListService(endpoint);
      if (response?.result) {
        setAllList(response?.result);
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };

  const deleteCheckList = async (checklistId: number) => {
    try {
      setError(null);
      let endpoint = `${Apinames.checklistDelete}?checklistId=${checklistId}`;
      const response = await deleteCheckListService(endpoint, {});
      if (response?.result) {
        getCheckList();
      }
    } catch (error) {
      setError("Failed to delete List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };
  const getQuestionList = async (checklistId: number) => {
    if (selectedChecklistId === checklistId && questionList.length > 0) {
      onPressDetailModal();
      return;
    }

    try {
      setError(null);
      setSelectedChecklistId(checklistId);
      setLoading(true);
      let endpoint = `${Apinames.checklistQuestions}?checklistId=${checklistId}`;
      const response = await getCheckListQuestionsService(endpoint);
      if (response?.result) {
        console.log("response", response);
        setQuestionList(response?.result);
        onPressDetailModal();
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const getResponsesList = async (checklistId: number) => {
    if (selectedChecklistId === checklistId && responsesList.length > 0) {
      onPressUserModal();
      return;
    }
    try {
      setError(null);
      setSelectedChecklistId(checklistId);
      setLoading(true);
      let endpoint = `${Apinames.checklistResponses}?checklistId=${checklistId}`;
      const response = await getCheckListResponseService(endpoint);
      if (response?.result) {
        setResponsesList(response?.result);
        onPressUserModal();
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const onPressDetailModal = () => {
    console.log("onPressDetailModal called");
    setShow(!show);
  };
  const onPressUserModal = () => {
    setUserShow(!usershow);
  };

  const navigateToUseTemplate = async (item: any) => {
    try {
      let endpoint = `${Apinames.checklistQuestions}?checklistId=${item.id}`;
      const questionList = await getCheckListQuestionsService(endpoint);

      const updatedItem = {
        ...item,
        data: questionList.result,
        isTemplate: false,
      };

      navigate("/newchecklist", {
        state: updatedItem,
      });
    } catch (error) {
      console.error("Failed to fetch questions:", error);
      // Optionally show an error toast or fallback
    }
  };

  const navigateToEditTemplate = async (item: any) => {
    const isTemplate = props.isTemplate;

    try {
      let endpoint = `${Apinames.checklistQuestions}?checklistId=${item.id}`;
      const questionList = await getCheckListQuestionsService(endpoint);

      console.log("questionList", questionList.result);
      const updatedItem = {
        ...item,
        data: questionList.result,
        isTemplate,
        edit: true,
      };

      navigate("/newchecklist", {
        state: updatedItem,
      });
    } catch (error) {
      console.error("Failed to fetch questions:", error);
      // Optionally show an error toast or fallback
    }
  };

  const templateDropDown=async()=>{
     try {
      setError(null);
      setDropdownLoading(true);

      let endpoint = `${Apinames.checklistAll}?isTemplate=true`;
      const response = await getCheckListService(endpoint);
      if (response?.result) {
        setDropDownList(response?.result)
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setDropdownLoading(false);
    }
  }
  return (
    <CheckList
      show={show}
      onPressDetailModal={onPressDetailModal}
      onPressUserModal={onPressUserModal}
      usershow={usershow}
      allList={allList}
      questionList={questionList}
      responsesList={responsesList}
      getResponsesList={getResponsesList}
      getQuestionList={getQuestionList}
      loading={loading}
      mainLoading={mainLoading}
      deleteCheckList={deleteCheckList}
      isTemplate={props.isTemplate}
      navigateToEditTemplate={navigateToEditTemplate}
      navigateToUseTemplate={navigateToUseTemplate}
      role={role}
      templateDropDown={templateDropDown}
      dropDownList={dropDownList}
      dropdownLoading={dropdownLoading}
    />
  );
};

export default CheckListScreen;
